import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import moment from 'moment';

const Footer = () => {
  const currentYear = moment().year();

  return (
    <Box
      sx={{
        color: 'black',
        textAlign: 'center',
        width: '100%',
        padding: '10px',
        boxSizing: 'border-box',
        position: 'relative',
        zIndex: 1200,
        marginTop: 'auto', // Para garantir que fique na parte inferior
      }}
    >
      <Typography variant="body1" sx={{ margin: 0, fontWeight: 'bold' }}>
        <Link
          component="a"
          href="https://www.thecodes.io"
          target="_blank"
          sx={{
            color: 'black',
            margin: '0 4px',
          }}
        >
          &copy; THE CODE
        </Link>
        {currentYear} All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
